/* eslint-disable react/require-default-props */
import React from 'react';
import { Card } from './styles';

interface AiManagementDataCardProps {
  title?: string;
  compact?: boolean;
  className?: string;
  children: React.ReactNode;
}

const AiManagementDataCard: React.FC<AiManagementDataCardProps> = ({
  title,
  compact = false,
  className = '',
  children,
}) => (
  <Card $compact={compact} className={`border overflow-hidden ${className}`}>
    {title ? <div className="data-card-title font-weight-bold border-bottom">{title}</div> : null}
    {children}
  </Card>
);

export default AiManagementDataCard;
